import { useRef } from 'react'
import { Button } from 'primereact/button'
import { Calendar } from 'primereact/calendar'

import DialogContainer, { DialogContainerProps } from '../common/pure/DialogContainer'
import { CalendarField } from '../common/pure/input-fields'
import { Column, Row } from '../common/pure/FlexContainer'
import { pi } from '../common/pure/PrimeIcon'
import { useDateRangeAgoState } from '../../hooks/state'
import t from '../../tools/t'

interface ExportDialogProps extends DialogContainerProps {
    onExport: (start: Date, end: Date) => void
}
export default function ExportDialog({ onExport, ...props }: ExportDialogProps) {
    const ref = useRef<Calendar>(null)
    const [exportStart, exportEnd, setExportRange] = useDateRangeAgoState()

    const onChangeExportRange = (dates: Date[]) => {
        const [start, end] = dates
        setExportRange(dates)
        if (start && end) ref.current?.hide()
    }

    const exportRange = async () => {
        if (!(exportStart && exportEnd)) return
        onExport(exportStart, exportEnd)
    }

    return (
        <DialogContainer {...props} header={t('export_dialog_title')}>
            <Column gap={1} style={{ marginTop: 8 }}>
                <CalendarField
                    ref={ref}
                    placeholder={t('export_calendar_placeholder')}
                    selectionMode="range"
                    value={[exportStart, exportEnd]}
                    onChange={(event) => onChangeExportRange(event.value as Date[])}
                />
                <Row alignment="center" arrangement="spaced" wide>
                    <Button
                        onClick={props.onHide}
                        label={t('common_cancel')}
                        text
                        severity="secondary"
                    />
                    <Button
                        onClick={exportRange}
                        icon={pi('download')}
                        label={t('common_download')}
                        severity="secondary"
                    />
                </Row>
            </Column>
        </DialogContainer>
    )
}
